import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import LogoutIcon from 'components/atoms/icons/logoutIcon';

const MenuItemLogout = () => {
  const { logout } = useAuth0();

  return (
    <button
      className="menu-item-icon"
      onClick={() => logout({ returnTo: window.location.origin })}
    >
      <div className="menu-item-icon__icon">
        <LogoutIcon />
      </div>
      <div className="menu-item-icon__text">Logout</div>
    </button>
  );
};

export default MenuItemLogout;
